import React, { useState, useEffect } from "react";
import { Drawer, Form, Input, Icon, Select } from "antd";

import { useAxios } from "../../../../shared/hooks/useAxios";
import { useNotification } from "../../../../shared/hooks/useNotification";

const { Option } = Select;

const DrawerHabilidades = ({ grupoId, habilidadeId, ativo, visible, onClose, atualizarListagem, form }) => {
    const { loading, notAuthorized, fetchData } = useAxios();
    const notify = useNotification();

    const [subgrupos, setSubgrupos] = useState([]);

    const { getFieldDecorator } = form;

    const handleSubmit = e => {
        e.preventDefault();
        form.validateFields((err, values) => {
            if (!err) {
                if (habilidadeId > 0) alterarHabilidade();
                else adicionarHabilidade();
            }
        });
    };

    const obterHabilidade = async () => {
        const { data, error } = await fetchData({
            method: "get",
            url: `/api/habilidades/obter-habilidade/${habilidadeId}`
        });

        if (!error) {
            form.setFieldsValue({ codigo: data.codigo, nome: data.nome, subgrupo: data.subgrupoId ?? undefined });
        } else {
            notify.error("Erro", error || "Ocorreu um erro inesperado. Por favor, tente novamente.");
        }
    };

    const carregarSubgrupos = async () => {
        const { data, error } = await fetchData({
            method: "get",
            url: "/api/habilidades/carregar-subgrupos"
        });

        if (!error) {
            setSubgrupos(data);
        } else {
            notify.error("Erro", error || "Ocorreu um erro inesperado. Por favor, tente novamente.");
        }
    };

    const adicionarHabilidade = async () => {
        const formData = new FormData();

        formData.append("grupoId", grupoId);
        formData.append("codigo", form.getFieldValue("codigo"));
        formData.append("nome", form.getFieldValue("nome"));
        if (form.getFieldValue("subgrupo")) formData.append("subgrupoId", form.getFieldValue("subgrupo"));

        const { error } = await fetchData({
            method: "post",
            url: "/api/habilidades/adicionar-habilidade",
            data: formData,
            headers: {
                "Content-Type": "multipart/form-data"
            }
        });

        if (!error) {
            notify.success("Sucesso", "Habilidade adicionada com sucesso!");
            atualizarListagem();
        } else {
            notify.error("Erro", error || "Ocorreu um erro inesperado. Por favor, tente novamente.");
        }
    };

    const alterarHabilidade = async () => {
        const formData = new FormData();

        formData.append("Id", habilidadeId);
        formData.append("codigo", form.getFieldValue("codigo"));
        formData.append("nome", form.getFieldValue("nome"));
        if (form.getFieldValue("subgrupo")) formData.append("subgrupoId", form.getFieldValue("subgrupo"));

        const { error } = await fetchData({
            method: "put",
            url: "/api/habilidades/alterar-habilidade",
            data: formData,
            headers: {
                "Content-Type": "multipart/form-data"
            }
        });

        if (!error) {
            notify.success("Sucesso", "Habilidade alterada com sucesso!");
            atualizarListagem();
        } else {
            notify.error("Erro", error || "Ocorreu um erro inesperado. Por favor, tente novamente.");
        }
    };

    const afterVisibleChange = visible => {
        form.resetFields();

        if (visible && habilidadeId > 0) obterHabilidade();
    };

    useEffect(() => {
        carregarSubgrupos();
    }, []);

    return (
        <Drawer
            title={habilidadeId > 0 ? "Editar Habilidade" : "Nova Habilidade"}
            className="drawer-add-cursos"
            width={720}
            onClose={onClose}
            visible={visible}
            style={{
                overflow: "auto",
                height: "calc(100% - 108px)",
                paddingBottom: "108px"
            }}
            maskClosable={false}
            afterVisibleChange={afterVisibleChange}
        >
            <div className="bloco-info">
                <Form className="form-add-curso" layout="horizontal" onSubmit={handleSubmit}>
                    <div className="bloco">
                        <Form.Item label="Código">{getFieldDecorator("codigo")(<Input disabled={!ativo} />)}</Form.Item>
                        <Form.Item label="Nome">
                            {getFieldDecorator("nome", {
                                rules: [
                                    {
                                        required: true,
                                        message: "Campo obrigatório"
                                    }
                                ]
                            })(<Input disabled={!ativo} />)}
                        </Form.Item>
                        <Form.Item label="Subgrupo">
                            {getFieldDecorator("subgrupo")(
                                <Select placeholder="Selecionar" allowClear={true}>
                                    {subgrupos.map(subgrupo => (
                                        <Option value={subgrupo.id} key={subgrupo.id}>
                                            {subgrupo.nome}
                                        </Option>
                                    ))}
                                </Select>
                            )}
                        </Form.Item>
                    </div>
                    <div className="ant-drawer-footer">
                        <button
                            type="button"
                            className="botao-secundario"
                            onClick={onClose}
                            style={{ marginRight: 20, display: "inline-block" }}
                        >
                            Voltar
                        </button>
                        {ativo && (
                            <button type="submit" className="botao-principal" disabled={loading}>
                                {loading ? <Icon type="loading" /> : null}
                                Salvar
                            </button>
                        )}
                    </div>
                </Form>
            </div>
        </Drawer>
    );
};

const FormDrawerHabilidades = Form.create({ name: "form-drawer-habilidades" })(DrawerHabilidades);

export default FormDrawerHabilidades;
